/* unplugin-vue-components disabled */import script from "./VideoItem.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoItem.vue?vue&type=script&setup=true&lang=js"

import "./VideoItem.vue?vue&type=style&index=0&id=040c91f9&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-040c91f9"]])

export default __exports__